<div class="d-flex flex-column main min-vh-100">
  <app-header *ngIf="isLoggedIn"></app-header>
  <app-campaign-banner *ngIf="isHomePage"></app-campaign-banner>
  <main class="container flex-fill">
    <router-outlet></router-outlet>
  </main>

  <app-footer *ngIf="isLoggedIn"></app-footer>

  <notifier-container></notifier-container>
  <app-call-support-action-button></app-call-support-action-button>
</div>
